/* Product page cross-sell (snippets/product-cross-sell.liquid).
   Reads <html data-xsell="hero|faq"> and <html data-xsell-design>, set by the snippet's preview gate,
   an Intelligems group script or the "Show to everyone" setting, and keeps the section in step:
   "faq" moves it below the FAQ section (or above the reviews), anything else keeps it below the hero. */
(function () {
  'use strict';

  var section = document.getElementById('PdpCrossSell');
  if (!section || section.hasAttribute('data-ready')) return;
  section.setAttribute('data-ready', '');

  var root = document.documentElement;
  var DESIGNS = ['cards', 'bundle', 'list', 'panel'];
  var DESIGN_NAMES = {
    cards: 'A<span class="pdp-xsell-preview__long"> · Cards</span>',
    bundle: 'B<span class="pdp-xsell-preview__long"> · Bundle</span>',
    list: 'C<span class="pdp-xsell-preview__long"> · List</span>',
    panel: 'D<span class="pdp-xsell-preview__long"> · Panel</span>'
  };
  var PLACEMENTS = {
    hero: '<span class="pdp-xsell-preview__long">Below </span>hero',
    faq: '<span class="pdp-xsell-preview__long">Below </span>FAQ'
  };
  var track = section.querySelector('[data-xsell-track]');
  var nav = section.querySelector('[data-xsell-nav]');
  var errorBox = section.querySelector('[data-xsell-error]');
  var home = document.createComment('pdp-cross-sell');
  section.parentNode.insertBefore(home, section);

  /* ---------- Placement and design ---------- */

  function faqTarget() {
    var faqs = document.querySelectorAll('[data-pdp-faq]');
    if (faqs.length) {
      var faq = faqs[faqs.length - 1];
      return { node: faq.closest('.shopify-section') || faq, where: 'after' };
    }
    var reviews = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
    if (reviews) return { node: reviews.closest('.shopify-section') || reviews, where: 'before' };
    var main = document.getElementById('MainContent');
    return main ? { node: main, where: 'append' } : null;
  }

  function place(placement) {
    if (placement === 'faq') {
      var target = faqTarget();
      if (target && !target.node.contains(section)) {
        if (target.where === 'after') target.node.parentNode.insertBefore(section, target.node.nextSibling);
        else if (target.where === 'before') target.node.parentNode.insertBefore(section, target.node);
        else target.node.appendChild(section);
      }
      section.setAttribute('data-placed', 'faq');
    } else {
      if (home.nextSibling !== section) home.parentNode.insertBefore(section, home.nextSibling);
      section.removeAttribute('data-placed');
    }
  }

  function apply() {
    var placement = root.getAttribute('data-xsell');
    var design = root.getAttribute('data-xsell-design');
    if (DESIGNS.indexOf(design) === -1) design = section.getAttribute('data-default-design');
    section.setAttribute('data-design', design);
    place(placement);
    updateNav();
    if (root.hasAttribute('data-xsell-preview')) renderPreview();
  }

  new MutationObserver(apply).observe(root, {
    attributes: true,
    attributeFilter: ['data-xsell', 'data-xsell-design', 'data-xsell-preview']
  });

  /* ---------- Prices ---------- */

  function formatMoney(cents) {
    var format = String((window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}').replace(/<[^>]*>/g, '');
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    function number(precision, thousands, decimal) {
      var parts = (cents / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    }
    var value;
    switch (match && match[1]) {
      case 'amount_no_decimals': value = number(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = number(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = number(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = number(2, "'", '.'); break;
      default: value = number(2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function items() {
    return Array.prototype.slice.call(section.querySelectorAll('[data-xsell-item]'));
  }

  function selection(item) {
    var input = item.querySelector('[data-xsell-variant]');
    if (input.tagName === 'SELECT') {
      var option = input.options[input.selectedIndex];
      return { id: Number(input.value), price: Number(option.getAttribute('data-price')), option: option };
    }
    return { id: Number(input.value), price: Number(input.getAttribute('data-price')) };
  }

  function setImage(img, src) {
    if (!img) return;
    if (!img.hasAttribute('data-original-src')) {
      img.setAttribute('data-original-src', img.getAttribute('src') || '');
      img.setAttribute('data-original-srcset', img.getAttribute('srcset') || '');
    }
    if (src) {
      img.removeAttribute('srcset');
      img.setAttribute('src', src);
    } else {
      img.setAttribute('src', img.getAttribute('data-original-src'));
      if (img.getAttribute('data-original-srcset')) img.setAttribute('srcset', img.getAttribute('data-original-srcset'));
    }
  }

  function refreshItem(item) {
    var chosen = selection(item);
    if (chosen.option) {
      var price = item.querySelector('[data-xsell-price]');
      var compare = item.querySelector('[data-xsell-compare]');
      if (price) price.textContent = chosen.option.getAttribute('data-price-label');
      if (compare) {
        var compareLabel = chosen.option.getAttribute('data-compare-label');
        compare.textContent = compareLabel || '';
        compare.hidden = !compareLabel;
      }
      var src = chosen.option.getAttribute('data-img');
      setImage(item.querySelector('.pdp-xsell__media img'), src);
      var thumb = section.querySelector('[data-xsell-thumb="' + item.getAttribute('data-xsell-item') + '"] img');
      setImage(thumb, src ? src.replace(/width=\d+/, 'width=240') : '');
    }
    refreshTotal();
  }

  /* ---------- Bundle total ---------- */

  function bundleItems() {
    return items().filter(function (item) {
      var check = item.querySelector('[data-xsell-check]');
      return check && check.checked && !check.disabled;
    });
  }

  function refreshTotal() {
    var chosen = bundleItems();
    var total = chosen.reduce(function (sum, item) { return sum + selection(item).price; }, 0);
    var all = items().filter(function (item) { return !item.querySelector('[data-xsell-check]').disabled; }).length;
    var totalEl = section.querySelector('[data-xsell-total]');
    var countEl = section.querySelector('[data-xsell-total-label]');
    var button = section.querySelector('[data-xsell-add-all]');
    var label = section.querySelector('[data-xsell-add-all-label]');
    if (totalEl) totalEl.textContent = formatMoney(total);
    if (countEl) countEl.textContent = 'Total pour ' + chosen.length + (chosen.length === 1 ? ' article' : ' articles');
    if (button && !button.classList.contains('is-added')) {
      button.disabled = chosen.length === 0;
      if (label) {
        label.textContent = chosen.length === all && all > 1
          ? 'Ajouter les ' + all + ' au panier'
          : chosen.length > 1 ? 'Ajouter ' + chosen.length + ' au panier' : 'Ajouter au panier';
      }
    }
    items().forEach(function (item) {
      var check = item.querySelector('[data-xsell-check]');
      var off = !check.checked || check.disabled;
      item.classList.toggle('is-off', off);
      var thumb = section.querySelector('[data-xsell-thumb="' + item.getAttribute('data-xsell-item') + '"]');
      if (thumb) thumb.classList.toggle('is-off', off);
    });
  }

  /* ---------- Add to cart ---------- */

  function addToCart(lines) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(base + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: lines })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  function run(button, lines, onDone) {
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    errorBox.hidden = true;
    addToCart(lines)
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
        onDone();
      })
      .catch(function (data) {
        errorBox.textContent = (data && (data.description || data.message)) || section.getAttribute('data-error-label');
        errorBox.hidden = false;
      })
      .then(function () {
        button.removeAttribute('aria-busy');
      });
  }

  function flashAdded(button, labelEl, label, restore) {
    button.classList.add('is-added');
    if (labelEl) labelEl.textContent = label;
    window.setTimeout(function () {
      button.classList.remove('is-added');
      restore();
    }, 2400);
  }

  section.addEventListener('click', function (event) {
    var add = event.target.closest('[data-xsell-add]');
    if (add) {
      var item = add.closest('[data-xsell-item]');
      var label = add.querySelector('[data-xsell-add-label]');
      run(add, [{ id: selection(item).id, quantity: 1 }], function () {
        flashAdded(add, label, section.getAttribute('data-added-label'), function () {
          if (label) label.textContent = section.getAttribute('data-add-label');
        });
      });
      return;
    }

    var addAll = event.target.closest('[data-xsell-add-all]');
    if (addAll) {
      var lines = bundleItems().map(function (bundleItem) { return { id: selection(bundleItem).id, quantity: 1 }; });
      if (!lines.length) return;
      run(addAll, lines, function () {
        flashAdded(addAll, section.querySelector('[data-xsell-add-all-label]'), section.getAttribute('data-added-label'), refreshTotal);
      });
      return;
    }

    var prev = event.target.closest('[data-xsell-prev]');
    var next = event.target.closest('[data-xsell-next]');
    if (prev || next) {
      var card = track.querySelector('[data-xsell-item]:not([data-current])');
      var step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
      track.scrollBy({ left: next ? step : -step, behavior: 'smooth' });
    }
  });

  section.addEventListener('change', function (event) {
    var item = event.target.closest('[data-xsell-item]');
    if (!item) return;
    if (event.target.matches('[data-xsell-variant]')) refreshItem(item);
    if (event.target.matches('[data-xsell-check]')) refreshTotal();
  });

  // Keep "This item" in the bundle on the variant picked in the product form.
  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    var current = section.querySelector('[data-current]');
    if (!variant || !current) return;
    var input = current.querySelector('[data-xsell-variant]');
    var check = current.querySelector('[data-xsell-check]');
    if (input.tagName === 'SELECT') {
      if (!input.querySelector('option[value="' + variant.id + '"]')) return;
      input.value = String(variant.id);
    } else {
      input.value = String(variant.id);
      input.setAttribute('data-price', variant.price);
    }
    check.disabled = !variant.available;
    if (!variant.available) check.checked = false;
    refreshItem(current);
  });

  /* ---------- Scroller arrows (panel design) ---------- */

  function updateNav() {
    if (!nav || !track) return;
    var scrollable = section.getAttribute('data-design') === 'panel' && track.scrollWidth > track.clientWidth + 4;
    nav.hidden = !scrollable;
    if (!scrollable) return;
    nav.querySelector('[data-xsell-prev]').disabled = track.scrollLeft <= 2;
    nav.querySelector('[data-xsell-next]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  }

  if (track) track.addEventListener('scroll', updateNav, { passive: true });
  window.addEventListener('resize', updateNav);

  /* ---------- Preview switcher ---------- */

  var bar;

  function setPreview(placement, design) {
    try {
      if (placement) sessionStorage.setItem('pdpXsell', placement);
      if (design) sessionStorage.setItem('pdpXsellDesign', design);
    } catch (e) {}
    var url = new URL(window.location.href);
    if (placement) {
      root.setAttribute('data-xsell', placement);
      url.searchParams.set('xsell', placement);
    }
    if (design) {
      root.setAttribute('data-xsell-design', design);
      url.searchParams.set('xsell_design', design);
    }
    window.history.replaceState(window.history.state, '', url);
    window.requestAnimationFrame(function () {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function exitPreview() {
    try {
      sessionStorage.removeItem('pdpXsell');
      sessionStorage.removeItem('pdpXsellDesign');
    } catch (e) {}
    var url = new URL(window.location.href);
    url.searchParams.delete('xsell');
    url.searchParams.delete('xsell_design');
    window.history.replaceState(window.history.state, '', url);
    if (bar) bar.remove();
    bar = null;
    root.removeAttribute('data-xsell-preview');
    root.removeAttribute('data-xsell-design');
    root.removeAttribute('data-xsell');
  }

  function renderPreview() {
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'pdp-xsell-preview';
      bar.setAttribute('role', 'toolbar');
      bar.setAttribute('aria-label', 'Cross-sell preview');
      var html = '<span class="pdp-xsell-preview__title">Cross-sell preview</span><span class="pdp-xsell-preview__group">';
      Object.keys(PLACEMENTS).forEach(function (key) {
        html += '<button type="button" data-preview-placement="' + key + '" title="' + (key === 'faq' ? 'Below the FAQ' : 'Below the hero') + '">' + PLACEMENTS[key] + '</button>';
      });
      html += '</span><span class="pdp-xsell-preview__group">';
      DESIGNS.forEach(function (key) {
        html += '<button type="button" data-preview-design="' + key + '" title="Design ' + DESIGN_NAMES[key].replace(/<[^>]*>/g, '') + '">' + DESIGN_NAMES[key] + '</button>';
      });
      html += '</span><button type="button" class="pdp-xsell-preview__exit" data-preview-exit>Exit</button>';
      bar.innerHTML = html;
      bar.addEventListener('click', function (event) {
        var button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-preview-exit')) return exitPreview();
        setPreview(button.getAttribute('data-preview-placement'), button.getAttribute('data-preview-design'));
      });
      document.body.appendChild(bar);
    }
    var placement = root.getAttribute('data-xsell');
    var design = section.getAttribute('data-design');
    bar.querySelectorAll('[data-preview-placement]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.getAttribute('data-preview-placement') === placement));
    });
    bar.querySelectorAll('[data-preview-design]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.getAttribute('data-preview-design') === design));
    });
  }

  items().forEach(function (item) {
    if (item.querySelector('select[data-xsell-variant]')) refreshItem(item);
  });
  refreshTotal();
  apply();
})();
